/**
 * Adapters should not be used in the store.
 * https://setnext.scalefast.ninja/scalefast/frontend/pandora/-/issues/600
 *
 * @deprecated
 */
export const GetProductsByFilterUseCaseAdapter = {
  buildParamsFromFilters: (feedId, filters, categoryId = undefined) => {
    return getParams(filters.filters, categoryId, feedId);
  },
  buildParamsFromSearchResults: filters => {
    return getParamsFromResultsPage(filters.filters);
  }
};
function getParamsFromResultsPage(filters) {
  const params = {};
  filters.forEach(filter => {
    const valuesString = filter.values.join(',');
    if (filter.groupBy === 'crit') {
      if (valuesString) {
        return params[`${filter.groupBy}`] = `${filter.name}:${valuesString}`;
      }
      return params[`${filter.groupBy}`] = `${filter.name}`;
    }
    if (filter.name === 'search') {
      return params['filters'] = `search:${filter.values}`;
    }
    return params[`${filter.groupBy}`] = `${valuesString}`;
  });
  return params;
}
function getParams(filters, categoryId, feedId) {
  const params = {};
  filters.forEach(filter => {
    const value = filter.values.join(',');
    // set params crit with a format name:value instead of only the value
    if (filter.groupBy === 'crit') {
      if (!params['crit']) {
        return params['crit'] = `${filter.name}:${value}`;
      }
      if (params['crit']) {
        return params['crit'] = ''.concat(params[`${filter.groupBy}`], '/', `${filter.name}:${value}`);
      }
    }
    // set the value parameter to a single value
    return params[`${filter.groupBy}`] = `${value}`;
  });
  if (params['crit']) {
    params['crit'] = `(cf.${params['crit']})`;
  }
  if (categoryId) {
    let parameters = `categoryID:${categoryId}`;
    if (params['crit']) {
      parameters = `${parameters}/${params['crit']}`;
    }
    params['crit'] = parameters;
  }
  if (feedId && !params['crit']) {
    params['crit'] = 'ALL';
  }
  if (feedId) {
    params['filters'] = `feedID:${feedId}`;
  }
  // set default parameters that we always want the API call to be called
  params['aggs_crit'] = 'custom_fields';
  params['aggs'] = 'platform!edition!cf_kw_series!cf_kw_characteristics!cf_kw_product_type!cf_kw_ages!cf_kw_concern!cf_kw_material!cf_kw_bvproductid!cf_kw_hexcode!cf_kw_is_product_in_offer';
  return params;
}
